import BottomSheetContent from '../../../components/BottomSheetComponents/BottomSheetContent'

type Props = {
  onDismiss: () => void
  heading?: string
}

export default function ExitLoadImpactBottomSheet({ onDismiss, heading = 'How does exit load impact my tax benefit?' }: Props) {
  return (
    <BottomSheetContent
      heading={heading}
      onDismiss={onDismiss}
      bottomSheetBodyClassName='!px-5'
    >
      <div className='text-[14px] font-normal leading-[150%] space-y-4 pb-4 text-[#6A6E6E]'>
        <p>
          Exit load is considered while calculating the gains or losses, and is therefore included in the tax
          benefit shown. However, it is a fee charged by the fund house for early withdrawals, and this amount is
          lost and cannot be reinvested.
        </p>

        <div className='pt-3 text-[#6A6E6E] font-medium'>
          Net Benefit = Tax Benefit - Exit Load
        </div>

        <p className='text-[#232323] font-medium'>
          We only recommend withdrawals where the tax benefit is significantly higher than the exit load.
        </p>
      </div>
    </BottomSheetContent>
  )
}

